/** Customers application API — credit limit, portal, navegación, CSVs, dunning, validación y store. */

export type {
  CustomerCreditExceededRow,
  CustomerCheckoutCustomerSnapshot,
  CustomerNormalizedPaymentLineForCredit,
} from './application/customerCreditLimit';
export { findCustomerCreditExceeded } from './application/customerCreditLimit';

export {
  buildCustomerPaymentMessage,
  ensureCustomerPortalLink,
  shareCustomerPaymentLink,
  sendCustomerWhatsAppReminder,
  openExternalUrl,
} from './application/customerPortal';

export { openCustomerCollectFromSale, openCustomerNewCustomer, openCustomerDetail } from './application/customerNavigation';

export { buildCustomerStatementCsv, type CustomerStatementParams } from './application/customerStatementCsv';
export { buildCustomerListCsv } from './application/customerListCsv';

export {
  getDueDateIso,
  getOverdueDays,
  isCustomerOverdue,
  getDunningLevel,
  DUNNING_LEVEL_LABEL,
  DUNNING_LEVEL_TONE,
  type DunningLevel,
} from './application/customerDunning';

export {
  getCustomerAmountFieldError,
  getCustomerChargeBlockedError,
  getCustomerCreditLimitConfirmation,
  getCustomerPaymentAmountError,
  getCustomerPaymentNoDebtHint,
  formatCustomerSelectedSaleLabel,
  getCustomerMixedDebtBreakdown,
  getCustomerMixedDebtPaymentHint,
  isCustomerAmountReady,
} from './application/validateCustomerManualMovement';

export {
  extractCustomerCommandCode,
  mapCustomerCommandError,
  type MappedCustomerCommandError,
} from './application/mapCustomerCommandError';

export { resetCustomerTabOverlays, useCustomerOverlayStore } from './store/useCustomerOverlayStore';

// Auto-added missing exports (smart)
export type { CustomerCollectIntent } from './store/useCustomerOverlayStore';
